export enum Locales {
    EN = "en",
    FR = "fr",
}

export const LOCALES = [
    { value: Locales.EN, caption: "English" },
    { value: Locales.FR, caption: "Français" },
];
